
export default {
  props: ["payment"],
};
